<div class="md:flex items-center ml-2 mr-2 mt-4">
  <app-form-field class="min-w-[200px] mb-2 mr-2">
    <mat-select [(ngModel)]="location" (selectionChange)="updateLocation()">
      <mat-option *ngFor="let o of locations" [value]="o">{{ o.name }}</mat-option>
    </mat-select>
  </app-form-field>
  <app-form-field class="min-w-[200px] mb-2">
    <mat-select [(ngModel)]="space" (selectionChange)="refresh()">
      <ng-container *ngFor="let o of spaces">

        <mat-option *ngIf="o.location.id == location.id" [value]="o">{{ o.name }}</mat-option>
      </ng-container>
    </mat-select>
  </app-form-field>

  <div class="spacer"></div>
  <div class="flex gap-4 mb-2">
    <div (click)="prev()" class="client_button btn_circle">
      <fa-icon icon="chevron-left"></fa-icon>
    </div>
    <div style="display: none">
      <input matInput [matDatepicker]="datepicker" [(ngModel)]="date" (dateChange)="refresh()" />
    </div>
    <div class="flex items-center md:text-xl text-lg font-bold">
      {{ dateRangeText(start, end) }}
    </div>
    <div class="flex items-center">
      <mat-datepicker-toggle [for]="datepicker"></mat-datepicker-toggle>
      <mat-datepicker #datepicker></mat-datepicker>
    </div>

    <div (click)="next()" class="client_button btn_circle">
      <fa-icon icon="chevron-right"></fa-icon>
    </div>
  </div>

  <!--<fa-icon icon="sync" (click)="refresh()"></fa-icon>-->
  <!--<div>
    <div class="app-btn" (click)="add()">
      <fa-icon icon="plus"></fa-icon> {{ _common.add }}
    </div>
  </div>-->
</div>

<app-dayview-time class="card" style="margin: 0px 10px 10px 10px" *ngIf="space" [hours]="28" [date]="date"
  [cssClass]="'ctlBookingCalendar'" (loadData)="loadData($event)" (itemClick)="openItem($event)"
  (timeClick)="openTime($event)" [rowFormat]="rowFormat" #calendar></app-dayview-time>